<template>
  <div>
    <div class="animated fadeIn m-3">
      <b-row>
        <b-col :cols="12" :md="12">
          <b-card>
            <b-row>
              <b-col>
                <div class="mb-2" style="font-size: larger">
                  <h3 class="m-0 text-center"><span style="color: #20A8D8">Superfluid.io Platform</span> Video Tutorials</h3>
                  <hr/>
                  <div class="mt-3 mb-3" style="line-height: 2rem">
                    <span v-show="false" style="color: #60C8FF">Learn more from our video tutorials</span><br/>
                    
                    <b-row v-if="videos">
                      <b-col :cols="12" :md="6" v-for="video in videos" :key="video.id">
												<div v-if="!!getYouTubeVideoKey(video.url)">
													<span>{{ video.title }}</span><br/>
													<iframe v-if="$isMobile()" width="100%" height="180" :src="`https://www.youtube.com/embed/` + getYouTubeVideoKey(url)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
													
													<iframe v-else width="100%" height="330" :src="`https://www.youtube.com/embed/` + getYouTubeVideoKey(video.url)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
												</div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col>
                <div class="mb-2">
                  <h5 class="m-0">Refer Superfluid Platform and get rewarded</h5>
                  <div>Grab your chance now!!</div>
                  
                  <hr/>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col :cols="12" :md=6>
                <b-row>
                  <b-col :cols="12" :md=3>
                    <label for="referral-link">
                      <h6 >Referral Link:</h6>
                    </label>
                  </b-col>
                  <b-col :cols="12" :md=9>
                    <b-form-input 
                      id="referral-link" 
                      size="md" 
                      v-model="refURL"
                      disabled="" 
                      style="color:#aaa"
                      :placeholder="refURL">
                    </b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col :cols="12" :md=6>
                <b-row class="mt-2">
                  <b-col :cols="6" :md=3>
                    <b-button
                      size="md" 
                      variant="primary"  
                      type="button"
                      v-clipboard:copy="refURL"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError">
                      <i class="fa fa-copy"></i> Copy
                    </b-button>
                  </b-col>
                  <b-col :cols="6" :md=9>
                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=` + refURL" target="_blank">
                      <i class="fa fa-facebook-official" style="font-size: 2.3rem"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    <a :href="`http://twitter.com/share?text=` + refURL" target="_blank">
                      <i class="fa fa-twitter" style="font-size: 2.3rem"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    <a :href="`whatsapp://send?text=` + refURL" data-action="share/whatsapp/share" target="_blank">
                      <i class="fa fa-whatsapp" style="font-size: 2.3rem"></i>
                    </a>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../../utils';

  export default {
    name: 'VideoTutorials',

    data() {
      const files = this.$store.state.files.fileList;
      const segments = this.$store.state.segments.segmentList;
      const videos = this.$store.state.general.video_tutorials;

      return {
        files: files,
        segments: segments,
        videos: videos,
        refCode: '',
        refURL: '',
        loading: true,
      };
    },

    mounted() {
      this.loading = false;
      this.refCode = this.referralInfo.code;
      this.refURL = this.referralInfo.info_url;
    },

    computed: {
      referralInfo() {
        var info = {};
        var user = this.$store.state.general.user;
        info['code'] = user.referral_code;
        info['info_url'] = user.info_url;
        info['url'] = user.referral_url;
        info['count'] = user.num_of_signup || 0;
        info['conversion'] = user.num_of_conversion || 0;
        info['points'] = user.points || 0;
        return info;
      },

      youTubeVideoKeys() {
        var keys = [];
        this.videos.slice(0, 4).forEach(video => {
          var key = '';
          if (video.url.indexOf('youtube') > -1) {
            keys.push(video.url.split("v=")[1]);
          }
          else if (video.url.indexOf('youtu.be') > -1) {
            keys.push(video.url.split(".be/")[1]);
          }
        });
        return keys;
      }
    },

    watch: {
      
    },

    methods: {
      abbreviateNumber(number) {
        var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
        var tier = Math.log10(number) / 3 | 0;
        if(tier == 0) {
          if (number % 1 !== 0) {
            return round(number)
          }
          return number;
        }
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);
        var scaled = number / scale;
        return scaled.toFixed(1) + suffix;
      },

      getYouTubeVideoKey(url) {
        var key = null;
        if (url.indexOf('youtube') > -1) {
					key = url.split("v=")[1];
        }
        else if (url.indexOf('youtu.be') > -1) {
					key = url.split(".be/")[1];
				}
				return key;
      },

      onCopy: function (e) {
        // alert('You just copied: ' + e.text);
        this.$bvToast.toast('Referral link copied!', {
          title: 'Successful',
          autoHideDelay: 500,
          variant: 'success',
          solid: true
        });
      },

      onCodeCopy: function (e) {
        this.$bvToast.toast('Referral code copied!', {
          title: 'Successful',
          autoHideDelay: 500,
          variant: 'success',
          solid: true
        });
      },

      onError: function (e) {
        // alert('Failed to copy texts');
      },

      createProject() {
        this.$router.push(`/sources`);
      }
    }
  };
</script>
